/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Already_Have_AccountInputs */

const en_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const ar_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لديك حساب بالفعل؟`)
};

const de_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben bereits ein Konto?`)
};

const es_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes una cuenta?`)
};

const fr_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà un compte ?`)
};

const it_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già un account?`)
};

const ja_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにアカウントをお持ちの場合`)
};

const ko_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 있으신가요?`)
};

const pt_br_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já possui uma conta?`)
};

const ru_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уже есть аккаунт?`)
};

const th_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีบัญชีอยู่แล้วใช่ไหม?`)
};

const tr_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten bir hesabın var mı?`)
};

const zh_cn_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有账号？`)
};

const zh_tw_btn_already_have_account = /** @type {(inputs: Btn_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有帳號？`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Btn_Already_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_already_have_account = /** @type {((inputs?: Btn_Already_Have_AccountInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Already_Have_AccountInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_already_have_account(inputs)
	if (locale === "ar") return ar_btn_already_have_account(inputs)
	if (locale === "de") return de_btn_already_have_account(inputs)
	if (locale === "es") return es_btn_already_have_account(inputs)
	if (locale === "fr") return fr_btn_already_have_account(inputs)
	if (locale === "it") return it_btn_already_have_account(inputs)
	if (locale === "ja") return ja_btn_already_have_account(inputs)
	if (locale === "ko") return ko_btn_already_have_account(inputs)
	if (locale === "pt_br") return pt_br_btn_already_have_account(inputs)
	if (locale === "ru") return ru_btn_already_have_account(inputs)
	if (locale === "th") return th_btn_already_have_account(inputs)
	if (locale === "tr") return tr_btn_already_have_account(inputs)
	if (locale === "zh_cn") return zh_cn_btn_already_have_account(inputs)
	return zh_tw_btn_already_have_account(inputs)
});